<template>
    <div class="networks-partners-form1">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <h6>Conexões > Parceiros</h6>

            <b-form-group label="Sua iniciativa atua em parceria?" label-for="hasPartner" class="required">
                <b-form-radio-group
                    id="hasPartner"
                    name="hasPartner"
                    v-model="$v.form.hasPartner.selected.$model"
                    :options="form.hasPartner.options"
                    :state="validateState('hasPartner')"
                    stacked
                    :disabled="getIsDisabled"
                    @change="onChangeHasPartner"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['atua_em_parceria'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['atua_em_parceria'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasPartner')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Cite aqui seus atuais parceiros."
                label-for="currentPartners"
                v-if="form.hasPartner.selected === 1"
            >
                <b-form-tags
                    id="currentPartners"
                    name="currentPartners"
                    v-model="form.currentPartners.selected"
                    size="lg"
                    class="mb-2"
                    add-on-change
                    no-outer-focus
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_atuais_parceiro'].value)
                    "
                >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                        <b-form-select
                            v-bind="inputAttrs"
                            v-on="inputHandlers"
                            :disabled="disabled || availablePartnersOptions.length === 0"
                            :options="availablePartnersOptions"
                        >
                            <template #first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Selecione</option>
                            </template>
                        </b-form-select>

                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                            <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info">{{
                                    tag
                                }}</b-form-tag>
                            </li>
                        </ul>
                    </template>
                </b-form-tags>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_atuais_parceiro'].value"
                />
            </b-form-group>

            <div class="invite" v-if="form.hasPartner.selected === 1">
                <div class="text">
                    Não encontrou seu parceiro na lista? Clique no botão abaixo para enviar um convite.
                </div>

                <b-button variant="dark" v-b-toggle.sidebar-backdrop-send-invite @click="openSidebar()">
                    <b-icon icon="envelope"></b-icon>
                    Enviar convite para um parceiro
                </b-button>
            </div>

            <b-form-group
                label="Sua iniciativa faz parte de alguma rede e/ou fórum?"
                label-for="hasNetwork"
                class="required"
            >
                <b-form-radio-group
                    id="hasNetwork"
                    name="hasNetwork"
                    v-model="$v.form.hasNetwork.selected.$model"
                    :options="form.hasNetwork.options"
                    :state="validateState('hasNetwork')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['parte_alguma_rede'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['parte_alguma_rede'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasNetwork')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Cite aqui as redes e fóruns que sua iniciativa faz parte."
                label-for="currentNetworks"
                v-if="form.hasNetwork.selected === 1"
            >
                <b-form-tags
                    id="currentNetworks"
                    name="currentNetworks"
                    v-model="form.currentNetworks.selected"
                    size="lg"
                    class="mb-2"
                    add-on-change
                    no-outer-focus
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_redes_faz_parte'].value)
                    "
                >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                        <b-form-select
                            v-bind="inputAttrs"
                            v-on="inputHandlers"
                            :disabled="disabled || availableNetworksOptions.length === 0"
                            :options="availableNetworksOptions"
                        >
                            <template #first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Selecione</option>
                            </template>
                        </b-form-select>

                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                            <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info">{{
                                    tag
                                }}</b-form-tag>
                            </li>
                        </ul>
                    </template>
                </b-form-tags>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_redes_faz_parte'].value"
                />
            </b-form-group>

            <div class="invite" v-if="form.hasNetwork.selected === 1">
                <div class="text">
                    Não encontrou sua rede ou fórum na lista? Clique no botão abaixo para enviar um convite.
                </div>

                <b-button variant="dark" v-b-toggle.sidebar-backdrop-send-invite @click="openSidebar()">
                    <b-icon icon="envelope"></b-icon>
                    Enviar convite para rede ou fórum
                </b-button>
            </div>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'FinancialSustainabilityForm1' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('FinancialSustainabilityForm1')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="changeRegisterForm('ResultsImpactsForm1')"
                        v-if="abbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-sidebar id="sidebar-backdrop-send-invite" title="Enviar convite" backdrop shadow right>
            <div>
                <div>
                    Ajude a Plataforma Potências Periféricas (PPP) a conectar mais e mais pessoas e iniciativas.
                    Preencha os campos abaixo e convide seus parceiros e amigos para participarem da plataforma.
                    <br /><br />Quanto maior a sua rede, melhor!
                </div>

                <b-form @submit.stop.prevent="onSidebarSubmit" novalidate>
                    <b-form-group label="Nome" label-for="name" class="required">
                        <b-form-input
                            id="name"
                            name="name"
                            v-model="$v.sidebarForm.name.$model"
                            type="text"
                            placeholder="Digite nome"
                            :state="validateStateSidebar('name')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('name')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="E-mail" label-for="email" class="required">
                        <b-form-input
                            id="email"
                            name="email"
                            v-model="$v.sidebarForm.email.$model"
                            type="text"
                            placeholder="Digite e-mail"
                            :state="validateStateSidebar('email')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateSidebar('email')">
                            <div v-if="!$v.sidebarForm.email.required">Campo obrigatório</div>
                            <div v-if="!$v.sidebarForm.email.email">Escreva um e-mail válido</div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="'dark'" class="radius-6 submit">Enviar convite</b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-modal
            ref="warning-modal-ref"
            body-class="warning-modal"
            :hide-header="true"
            :hide-footer="true"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <b-modal ref="warning-sidebar-modal-ref" :hide-header="true" :hide-footer="true" body-class="warning-modal">
            <div class="content">
                <SuccessMsgModal msg="Convite enviado com sucesso!" />
            </div>

            <div class="footer-buttons">
                <b-button
                    variant="primary"
                    v-b-toggle.sidebar-backdrop-send-invite
                    @click="hideModal('warning-sidebar-modal-ref')"
                >
                    Entendi
                </b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { NetworksPartnersApi } from '../../api/networks-partners'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const networksPartnersApi = new NetworksPartnersApi()

export default {
    components: { SuccessMsgModal, WarningMsgModal, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            progress: 66.48,
            isUpdate: false,
            networksPartners: null,
            isDisabled: null,
            message: null,
            authorizationData: null,
            sidebarForm: {
                name: null,
                email: null
            },
            currentPartnersOptions: [],
            form: {
                hasPartner: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                currentPartners: {
                    selected: [],
                    options: []
                },
                hasNetwork: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                currentNetworks: {
                    selected: [],
                    options: []
                },
                currentPartnersText: null,
                currentNetworksText: null
            }
        }
    },
    validations: {
        form: {
            hasPartner: {
                selected: { required }
            },
            hasNetwork: {
                selected: { required }
            }
        },
        sidebarForm: {
            name: { required },
            email: { required, email }
        }
    },
    computed: {
        availablePartnersOptions() {
            return this.form.currentPartners.options.filter(
                opt => this.form.currentPartners.selected.indexOf(opt) === -1
            )
        },
        availableNetworksOptions() {
            return this.form.currentNetworks.options.filter(
                opt => this.form.currentNetworks.selected.indexOf(opt) === -1
            )
        },
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        validateStateSidebar(nameField) {
            const { $dirty, $error } = this.$v.sidebarForm[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            this.setIsLoading(true)
            axios
                .all([networksPartnersApi.getPartnersForum()])
                .then(response => {
                    const data = this.receiveData

                    this.currentPartnersOptions = response[0].data.map(item => ({
                        value: item.id,
                        text: item.nome_organizacao
                    }))

                    this.form.hasPartner.selected = data.atua_em_parceria
                    this.form.hasNetwork.selected = data.parte_alguma_rede

                    this.form.currentPartners.selected = this.currentPartnersOptions
                        .filter(item => data.id_atuais_parceiro.includes(item.value))
                        .map(opt => opt.text)

                    this.form.currentNetworks.selected = this.currentPartnersOptions
                        .filter(item => data.id_redes_faz_parte.includes(item.value))
                        .map(opt => opt.text)

                    const newPartnersForum = this.currentPartnersOptions.map(item => item.text)

                    this.form.currentPartners.options = [...newPartnersForum]
                    this.form.currentNetworks.options = [...newPartnersForum]

                    this.form.currentPartnersText =
                        data.id_atuais_parceiro === null
                            ? null
                            : data.id_atuais_parceiro.filter(item => typeof item !== 'number')[0].currentPartnersText

                    this.form.currentNetworksText =
                        data.id_redes_faz_parte === null
                            ? null
                            : data.id_redes_faz_parte.filter(item => typeof item !== 'number')[0].currentNetworksText

                    this.filterData()
                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            this.setIsLoading(true)
            axios
                .all([networksPartnersApi.getNetworksPartners(), networksPartnersApi.getPartnersForum()])
                .then(response => {
                    const data = response[0].data.data

                    this.currentPartnersOptions = response[1].data.map(item => ({
                        value: item.id,
                        text: item.nome_organizacao
                    }))

                    if (data !== null) {
                        this.networksPartners = data
                        this.form.hasPartner.selected = data.atua_em_parceria
                        this.form.hasNetwork.selected = data.parte_alguma_rede

                        this.form.currentPartners.selected = this.currentPartnersOptions
                            .filter(item => data.id_atuais_parceiro.includes(item.value))
                            .map(opt => opt.text)

                        this.form.currentNetworks.selected = this.currentPartnersOptions
                            .filter(item => data.id_redes_faz_parte.includes(item.value))
                            .map(opt => opt.text)

                        this.setProgress(data.percentual)
                    }

                    const newPartnersForum = this.currentPartnersOptions.map(item => item.text)

                    this.form.currentPartners.options = [...newPartnersForum]
                    this.form.currentNetworks.options = [...newPartnersForum]

                    this.form.currentPartnersText =
                        data.id_atuais_parceiro === null
                            ? null
                            : data.id_atuais_parceiro.filter(item => typeof item !== 'number')[0].currentPartnersText

                    this.form.currentNetworksText =
                        data.id_redes_faz_parte === null
                            ? null
                            : data.id_redes_faz_parte.filter(item => typeof item !== 'number')[0].currentNetworksText
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                ...this.networksPartners,
                atua_em_parceria: this.form.hasPartner.selected,
                parte_alguma_rede: this.form.hasNetwork.selected,
                percentual: currentProgress
            }

            data.id_atuais_parceiro = this.currentPartnersOptions
                .filter(item => this.form.currentPartners.selected.includes(item.text))
                .map(opt => opt.value)

            data.id_atuais_parceiro = [
                ...data.id_atuais_parceiro,
                { currentPartnersText: this.form.currentPartnersText }
            ]

            data.id_redes_faz_parte = this.currentPartnersOptions
                .filter(item => this.form.currentNetworks.selected.includes(item.text))
                .map(opt => opt.value)

            data.id_redes_faz_parte = [
                ...data.id_redes_faz_parte,
                { currentNetworksText: this.form.currentNetworksText }
            ]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? networksPartnersApi.updateNetworksPartners(data)
                : networksPartnersApi.createNetworksPartners(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message
                    this.isUpdate ? this.changeStatusDisabled(true) : this.showModal('warning-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSidebarSubmit(event) {
            this.$v.sidebarForm.$touch()
            if (this.$v.sidebarForm.$anyError) {
                return
            }

            const data = { nome: this.sidebarForm.name, email: this.sidebarForm.email }

            this.setIsLoading(true)
            networksPartnersApi
                .sendInvitation(data)
                .then(response => {
                    this.showModal('warning-sidebar-modal-ref')
                    this.hideModal('warning-sidebar-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        openSidebar() {
            this.$v.sidebarForm.$reset()
            this.sidebarForm.name = null
            this.sidebarForm.email = null
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'ResultsImpactsForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        onChangeHasPartner() {
            this.form.currentPartnersText = null
            this.form.currentPartners.selected = []
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getNetworksPartners(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.hasPartner.options = this.form.hasPartner.options.filter(
                    x => Number(this.form.hasPartner.selected) === x.value
                )

                this.form.hasNetwork.options = this.form.hasNetwork.options.filter(
                    x => Number(this.form.hasNetwork.selected) === x.value
                )
            }
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./NetworksPartnersForm1-light-theme.css"></style>
<style scope src="./NetworksPartnersForm1-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-networks-partners-forms/NetworksPartnersForm1.vue